module.exports = __webpack_public_path__ + "media/dashboard/assets/images/close-c2dce50200b965379ddeee315de7fed6.svg";